import React, { useEffect } from 'react';
import useUserProfile from 'hooks/useKeycloakUser';
import { useLocation, useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get('ref') || '/';

  const { keycloak, user } = useUserProfile();

  useEffect(() => {
    if (keycloak.authenticated && user) {
      navigate(ref, { replace: true });
    }
  }, [keycloak.authenticated, navigate, ref, user]);

  return (
    <>
      {!keycloak.authenticated ? (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-blue-100 to-purple-200 p-4">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Вход в систему</h2>
            <button
              className="w-full rounded bg-[#631d76] px-6 py-3 font-semibold text-white transition hover:bg-[#674d81]"
              onClick={() => keycloak.login()}
            >
              Войти через Keycloak
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Login;
